Progress:
<strong
  ><span class="has-text-grey">{{ correctedTablesCount() }}</span
  >/{{ totalTablesCount() }}</strong
>
tables reviewed

<progress class="progress is-primary" [value]="progressPercent()" max="100"></progress>

@for (table of tablesOfCurrentPage(); track $index) {
  @let transactionType = table.mapping.transactionType;
  @let columns = getColumnsByTransactionType(table);
  @let rows = getRows(table);

  <table class="table is-narrow is-bordered mb-1 is-striped">
    <thead class="has-background-white-ter">
      <tr>
        <th class="table-action"></th>
        @for (column of columns; track $index) {
          <th>{{ column | translate }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track $index) {
        @let isIgnored = row.ignoreTransaction === true;
        <tr
          [class.ignored-row]="isIgnored"
          [ngxTippy]="isIgnored ? ignoreReasonTemplate : null"
          [tippyContext]="{ reason: row.ignoreReason }"
        >
          <td class="table-action">
            <div class="is-flex is-justify-content-center is-align-items-center">
              <button fino-button icon="Bin" (click)="removeRow(table, row)"></button>
            </div>
          </td>
          @for (column of columns; track $index) {
            @let confidence = getConfidence(row, column);
            @let metadata = getMetadataForField(row, column);
            @let alreadyEdited = $safeNavigationMigration(metadata?.edited);
            @let hasViolations =
              $safeNavigationMigration(metadata?.validationViolations?.length) >= 1;
            <td
              [ngxTippy]="isIgnored ? null : tooltipTemplate"
              [tippyContext]="{ data: metadata }"
              [class.has-background-danger-light]="
                !isIgnored &&
                confidence != null &&
                confidence < threshold() &&
                !alreadyEdited &&
                !hasViolations
              "
              [class.has-background-danger]="!isIgnored && hasViolations && !alreadyEdited"
              class="is-relative"
              #tdElement
            >
              @if (metadata?.showInput && !isIgnored) {
                <app-cell-editor
                  [value]="row[column]"
                  [tableType]="transactionType"
                  [type]="column"
                  [tdElement]="tdElement"
                  (cellEdited)="cellEdited($event, table, row, column)"
                ></app-cell-editor>
              }
              <p
                class="is-fullwidth cell-text"
                [class.is-clickable]="!isIgnored"
                (click)="!isIgnored && makeFieldEditable(row, column)"
                [innerHTML]="row[column] | consecutiveZeros"
              ></p>
            </td>
          }
        </tr>
      }
      <tr>
        <td class="table-action">
          <div class="is-flex is-justify-content-center is-align-items-center">
            <button
              fino-button
              type="button"
              (click)="addNewRow(table)"
              icon="Layers Grid Add"
              class="mb-4 mt-0"
            ></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
}

<div class="is-flex is-justify-content-center is-align-items-center">
  <app-new-table
    class="is-flex is-fullwidth"
    (transactionTypeSelected)="addNewTable($event)"
  ></app-new-table>
</div>

<ng-template #tooltipTemplate let-name let-data="data">
  <div>
    @if (data?.confidence != null) {
      Confidence: {{ data.confidence | percent }} <br />
    }
    @if (data?.validationViolations) {
      <ul>
        @for (violation of data?.validationViolations; track $index) {
          <li class="has-text-danger">
            {{ 'correctionTool.error.' + violation.errorCode | translate }} <br />
          </li>
        }
      </ul>
    }
  </div>
</ng-template>

<ng-template #ignoreReasonTemplate let-reason="reason">
  <div>
    {{ reason || 'Transaction ignored' }}
  </div>
</ng-template>
